module.exports = __webpack_public_path__ + "media/jindocoin_wow_nft.f14d3411.mp4";